import { banners } from '@shared/config/constants/Banners';

export const HRLLookupBanner = {
  en: banners.main_video_new_en,
  ar: banners.main_video_new_ar,
  isVideo: true,
};
